import { ComputedRef, UnwrapNestedRefs, computed, reactive } from "vue";
import { cloneDeep } from "lodash";

interface ChangeTracker<T> {
  value: UnwrapNestedRefs<T>;
  hasChanged: ComputedRef<boolean>;
  resetInitialValue: () => void;
  resetValue: () => void;
}

const useReactiveChangeTracker = <T extends object>(
  initialValue: T
): ChangeTracker<T> => {
  const value = reactive(initialValue);
  const trackingValue = reactive(cloneDeep(initialValue));
  const initialValueRef = reactive(cloneDeep(initialValue));

  const resetInitialValue = () => {
    Object.assign(trackingValue, initialValue);
  };

  const resetValue = () => {
    Object.assign(value, initialValueRef);
  };

  const hasChanged = computed(() => {
    return JSON.stringify(value) !== JSON.stringify(trackingValue);
  });

  return {
    value,
    hasChanged,
    resetInitialValue,
    resetValue,
  };
};

export default useReactiveChangeTracker;
